import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { Color, CommonProperties, CommonStyles } from '../styles';
import { scale } from '../utils/scale.utils';
import BaseText from './BaseText';
import Icon from './Icon';
import RowView from './RowView';

const CheckboxSquare = ({ label, value, onChange, ...rest }) => {
  const activeStyles = value
    ? { backgroundColor: Color.primary }
    : {
        borderWidth: 1,
        borderColor: Color.text.gray,
      };

  return (
    <TouchableOpacity onPress={() => onChange(!value)} {...rest}>
      <RowView style={{ alignItems: 'center' }}>
        <View
          style={[
            {
              width: scale(24),
              height: scale(24),
              ...CommonProperties.borderRadius2,
              ...CommonProperties.centerAlignment,
              ...CommonProperties.mr3,
            },
            activeStyles,
          ]}
        >
          {value ? <Icon name="check" style={{ color: Color.accent, fontSize: 18 }} /> : null}
        </View>
        <BaseText style={CommonStyles.h3}>{label}</BaseText>
      </RowView>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({});

export default CheckboxSquare;
